import React from "react";
import { CUSTOMER_UPDATE_SUCCESS, ERROR_STATUS, SUCCESS_STATUS, UPDATE_FAILURE } from "../../../../constants";

export const StatusAlerts = ({ deleteAssessmentNoteState, successMessage }) => (
  <>
    {deleteAssessmentNoteState === SUCCESS_STATUS && <div className="alert alert-success d-inline-block">{CUSTOMER_UPDATE_SUCCESS}</div>}
    {deleteAssessmentNoteState === ERROR_STATUS && <div className="alert alert-danger d-inline-block">{UPDATE_FAILURE}</div>}
    {successMessage && <div className="alert alert-success d-inline-block">{successMessage}</div>}
  </>
);
